import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import {
    VerificationService,
    SuccessResponse,
    CopyToClipboard,
} from '@sheerid/jslib';
import { SUCCESS_REDIRECT } from '../../constants';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_blank');
    win.focus();
};

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}'; // eslint-disable-line no-template-curly-in-string
    const redirectDestination = `${SUCCESS_REDIRECT}${rewardCode}`;
    const noCodeType = verificationService.programTheme.config.offerType === 'noCode';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-space-top-md">
                <div className="sid-header__title sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-footer sid-l-space-top-sm">
                    <FormattedHTMLMessage
                        id="step.success.discountsAvailable"
                        defaultMessage="The following discounts are available with the discount code."
                    />
                </div>

                <div className="sid-header__subtitle">
                    <FormattedHTMLMessage
                        id="preSubtitle.title"
                        defaultMessage="Google Pixel smartphone 10% discount¹"
                    />
                    <ul className="sid-header__subtitle--ul">
                        <li className="sid-header__subtitle--bullet">
                            <FormattedHTMLMessage
                                id="preSubtitle.bullet5"
                                defaultMessage="Google Pixel 8"
                            />
                        </li>
                        <li className="sid-header__subtitle--bullet">
                            <FormattedHTMLMessage
                                id="preSubtitle.bullet4"
                                defaultMessage="Google Pixel 8 Pro"
                            />
                        </li>
                        <li className="sid-header__subtitle--bullet">
                            <FormattedHTMLMessage
                                id="preSubtitle.bullet3"
                                defaultMessage="Google Pixel 7a"
                            />
                        </li>
                        <li className="sid-header__subtitle--bullet">
                            <FormattedHTMLMessage
                                id="preSubtitle.bullet2"
                                defaultMessage="Google Pixel 7 Pro"
                            />
                        </li>
                    </ul>
                </div>
                <div className="sid-header__subtitle sid-l-space-top-md">
                    <FormattedHTMLMessage
                        id="step.success.subtitle"
                        defaultMessage={
                            `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                        }
                    />
                </div>
            </div>

            {
                noCodeType ? null
                    : (
                        <>
                            <div className="sid-reward-code sid-l-space-top-md sid-h-jumbo-text">
                                {rewardCode}
                            </div>

                            <div className="sid-l-space-top-md sid-h-bold-text">
                                <CopyToClipboard
                                    textToCopy={rewardCode}
                                    notificationText={<FormattedHTMLMessage id="copied" defaultMessage="Copied" />}
                                >
                                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                                </CopyToClipboard>
                            </div>
                        </>
                    )
            }

            <div className="sid-footer sid-l-space-top-md">
                <FormattedHTMLMessage
                    id="step.success.emailNotification"
                    defaultMessage="We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com"
                />
            </div>

            <div className="sid-footer sid-l-space-top-sm">
                <FormattedHTMLMessage
                    id="step.success.howToUse"
                    defaultMessage="We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com"
                />
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    type="button"
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                </button>
            </div>

            <div className="sid-footer sid-l-space-top-md">
                <FormattedHTMLMessage id="termsAndConditions" defaultMessage="¹Google Pixel pulls 10%. Promotional Code benefits are provided by Google Joint Company. It is only available for Japan\'s Google Store, and the following terms of use apply. You live in Japan and can only be used when the delivery address is in Japan. Target only 18 years old or older.<br><br>The promotion code should be used in Japan\'s Google Store by 23:59/31/2013 (Japan Time). If it is not available before it, expires and expired. SHEERID adapts to those who have identified qualifications of the study code.<br>Other promotional codes and benefits such as other simultaneous purchase bonus and discounts in the same period can not be used in combination." />
            </div>

            <div className="sid-footer sid-l-space-top-lg sid-h-small-text">
                <FormattedMessage id="companyName" defaultMessage="{Company}">
                    {companyName => (
                        <FormattedHTMLMessage
                            id="step.success.verificationOnly"
                            defaultMessage={`
                                SheerID handles verification only.
                                Now that you've been approved, please direct all questions about the
                                promotion terms and/or code use to {companyName} customer service.
                            `}
                            values={{ companyName }}
                        />
                    )}
                </FormattedMessage>
            </div>
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;
